import { createContext } from 'react';

/**
 * True while visualisations render inside a live report (the report-builder
 * editor preview, the published viewer, and the public/open report view all
 * render widgets through the shared Canvas, which provides `true`).
 *
 * Shared chart/data components read this to suppress their inline card chrome
 * (title header + info-icon popover): a live report supplies its own headings
 * via HeadingWidget, so the per-visualisation title and Details popover are
 * redundant there. Defaults to `false` so dashboard and analysis views keep
 * their chrome.
 *
 * @type {React.Context<boolean>}
 */
const LiveReportRenderContext = createContext(false);

export default LiveReportRenderContext;
